import { Text } from "@mantine/core";
import { MainTemplate } from "components/template";

const About = () => {
  return (
    <MainTemplate>
      <Text>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Architecto
        adipisci eius ex, dolor harum reprehenderit deleniti, quibusdam rem,
        iure suscipit necessitatibus delectus soluta ratione natus consequatur
        consectetur repellendus sequi tempore.
      </Text>
    </MainTemplate>
  );
};

export default About;
